const getUFFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'sigla', label: 'Sigla' },
  { name: 'estado', label: 'Estado', initial: true },
  {
    name: 'pais',
    label: 'País',
    type: 'select',
    options: drops?.Pais,
    multiple: true,
  },
  { name: 'codigo_ibge', label: 'Código IBGE', type: 'number' },
  { name: 'icms_interno', label: 'ICMS Interno', type: 'number' },
];

export default getUFFilterFields;
